import { UserRole } from "../constants/userRoles.ts";

export function getDefaultRouteForRole(role) {
  switch (role) {
    case UserRole.SYSTEM_ADMIN:
      return "/dashboard";
    case UserRole.TENANT_ADMIN:
      return "/clientAdminDashboard";
    case UserRole.TENANT_STAFF:
      return "/staffDashboard";
    default:
      return "/";
  }
}